import { z } from "zod";

export const EventIdSchema = z.string().brand("EventId");

export type EventId = z.infer<typeof EventIdSchema>;

/**
 * Schema that coerces string/number/bigint to branded EventId.
 * Use this at API/WebSocket boundaries where the input might be any of these types.
 */
export const CoercingEventIdSchema = z
	.union([z.string(), z.number(), z.bigint()])
	.transform((val) => String(val))
	.pipe(EventIdSchema);

export function createEventId(value: string | number | bigint): EventId {
	return EventIdSchema.parse(String(value));
}

export function isEventId(value: unknown): value is EventId {
	try {
		EventIdSchema.parse(String(value));
		return true;
	} catch {
		return false;
	}
}

/**
 * Convert EventId to number for APIs that require numeric IDs.
 * Throws if the ID is not a valid number.
 */
export function eventIdToNumber(id: EventId): number {
	const num = Number(id);
	if (Number.isNaN(num)) {
		throw new Error(`Invalid EventId: "${id}" is not a valid number`);
	}
	return num;
}
